var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2917 10C17.2917 10.3452 17.0119 10.625 16.6667 10.625H4.84227L8.77527 14.5581C9.01935 14.8021 9.01935 15.1979 8.77527 15.4419C8.53119 15.686 8.13552 15.686 7.89144 15.4419L2.89144 10.4419C2.77419 10.3248 2.70835 10.1658 2.70835 10C2.70835 9.83425 2.77419 9.67525 2.89144 9.55809L7.89144 4.55809C8.13552 4.314 8.53119 4.314 8.77527 4.55809C9.01935 4.80217 9.01935 5.19783 8.77527 5.44192L4.84227 9.375H16.6667C17.0119 9.375 17.2917 9.65484 17.2917 10Z",
    fill: "#6A855C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e67235a4abfb8372515ddc88d6642d7f.svg";
export { ForwardRef as ReactComponent };